/**
 * PMS iş ekranlarının metinleri (M7b3; plan M7 Task 14a–14d): Maintenance Plan, Job Card, Work
 * Orders, iş emri detayı, onay, iptal ve düzeltme, History. Ekran ve alan adları tasarımdaki gibi
 * İngilizce (`gemi-pms-ekipman.jpeg`); Türkçe ikinci dil. Hata kodları
 * `PMS_WORK_ERROR_CODES` listesini karşılar [NR496 4.1.5] (`locales.test.ts`).
 */

export const pmsWorkErrorsEn = {
  INVALID_PASSWORD: 'The password is wrong.',
  INVALID_CREDENTIALS: 'The password is wrong.',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Wait a few minutes and try again.',
  REAUTHENTICATION_REQUIRED: 'Enter your password to sign.',
  INVALID_JOB: 'Some job fields are invalid.',
  DUPLICATE_JOB_CODE: 'Another job on this vessel already uses this code.',
  JOB_DELETED: 'The job has been deleted.',
  JOB_INACTIVE: 'The job is not active.',
  JOB_EQUIPMENT_FIXED: 'The item of an existing job cannot be changed.',
  JOB_EQUIPMENT_MISMATCH: 'The job belongs to another item.',
  JOB_REQUIRED: 'A planned work order needs a job.',
  JOB_NOT_ALLOWED: 'An unplanned work order is not linked to a job.',
  COUNTER_REQUIRED: 'A running hour interval needs a running hour counter on the item or above it.',
  COUNTER_NOT_ANCESTOR: 'The counter must be on the item or one of its parents.',
  COUNTER_LOCKED: 'The counter cannot change after work has been recorded.',
  BASELINE_LOCKED: 'The previous-system record cannot change after work has been recorded.',
  BASELINE_HOURS_REQUIRED: 'Enter the running hours of the last time done.',
  CLASS_INTERVAL_EXCEEDS_CMS: 'A class item must be done at least every 60 months.',
  INVALID_INTERVAL: 'The interval is invalid.',
  INTERVAL_UNCHANGED: 'The new interval is the same as the current one.',
  INTERVAL_CHANGE_REASON_REQUIRED: 'Write why the interval is changed.',
  INTERVAL_CHANGE_REQUIRES_REQUEST:
    'Work has been recorded for this job: request the interval change instead.',
  INTERVAL_BASIS_MAKER_REQUIRED:
    'Extending beyond the maker interval needs a class or company basis.',
  INTERVAL_MISMATCH: 'The interval does not match the plan. Reload and try again.',
  DIRECTION_MISMATCH: 'The interval change does not match the plan. Reload and try again.',
  UNKNOWN_CONDITION_POINT: 'A measurement point was not found.',
  UNKNOWN_DOCUMENT: 'The linked document was not found.',
  UNKNOWN_ROLE: 'The role was not found.',
  UNKNOWN_USER: 'The person was not found.',
  UNKNOWN_MATERIAL: 'A part was not found in the stock list.',
  PROVISION_NOT_SPARE_PART:
    'Provisions cannot be used as spare parts. Remove the item from the list.',
  UNKNOWN_DEFECT: 'The defect was not found.',
  INSTRUCTION_SECTION_MISMATCH: 'The instruction must be a document in PMS Instructions.',
  MANUAL_SECTION_MISMATCH: 'The manual must be a document in Manuals.',
  INSTRUCTION_MISMATCH: 'The instruction of the work order does not match. Reload and try again.',
  INVALID_WORK_ORDER: 'Some work order fields are invalid.',
  INVALID_TRANSITION: 'The work order cannot move to this status.',
  OPEN_WORK_ORDER_EXISTS: 'This job already has an open work order.',
  WORK_ORDER_CANCELLED: 'The work order has been cancelled.',
  WORK_ORDER_REPORTED: 'The work order has been reported and cannot be changed.',
  WORK_ORDER_ALREADY_REPORTED: 'The work order has already been reported.',
  WORK_ORDER_FIXED: 'These work order fields cannot be changed.',
  WORK_ORDER_MISMATCH: 'The record belongs to another work order.',
  WO_NO_MISMATCH: 'The work order number does not match. Reload and try again.',
  TARGET_ON_NOT_ALLOWED: 'A planned work order takes its due date from the plan.',
  CANCEL_REASON_REQUIRED: 'Write why the work order is cancelled.',
  HORIZON_OUT_OF_RANGE: 'Choose between 1 and 365 days.',
  SAFETY_CHECK_INCOMPLETE: 'Tick every safety item before reporting.',
  WORK_DESCRIPTION_REQUIRED: 'Describe the work performed.',
  PERFORMER_REQUIRED: 'Name at least one person who did the work.',
  RESULT_REQUIRED: 'Choose the result.',
  RESULT_INCONSISTENT: 'A failed checklist item cannot give a passed result.',
  CHECKLIST_INCOMPLETE: 'Answer every checklist item.',
  CHECKLIST_INVALID: 'The checklist answers do not match the job.',
  CHECKLIST_VALUE_REQUIRED: 'Enter the value of every measured checklist item.',
  CHECKLIST_REMARK_REQUIRED: 'Write a remark for every failed checklist item.',
  CONDITION_AFTER_REQUIRED: 'Choose the condition of the item after the work.',
  OVERDUE_REASON_REQUIRED: 'The job is overdue: write the reason for the delay.',
  CM_REPORT_REQUIRED:
    'Attach the condition monitoring report or confirm that the service supplier will send it.',
  CM_REPORT_NOT_PENDING:
    'A report can be added to this record only when it was declared as awaited from the supplier.',
  INVALID_CONDITION: 'The condition is not valid.',
  INVALID_WORK_HOURS: 'Man-hours must be more than 0 and at most 10,000.',
  RUNNING_HOURS_REQUIRED: 'Enter the running hours at completion.',
  RUNNING_HOURS_MISMATCH: 'The running hours do not match the counter.',
  HOURS_AFTER_CURRENT: 'The running hours cannot be above the current counter value.',
  METER_EVENT_HAS_LATER_READINGS: 'The meter has later readings.',
  INVALID_SPARE_PARTS: 'Check the parts used.',
  DONE_ON_MISMATCH: 'The date does not match the ship time. Reload and try again.',
  DUE_MISMATCH: 'The due date changed. Reload and try again.',
  FIRST_ORIGINAL_DUE_MISMATCH: 'The first original due date changed. Reload and try again.',
  CYCLE_MISMATCH: 'The plan changed. Reload and try again.',
  CE_MISMATCH: 'The survey flag does not match the job.',
  INVALID_CE_COPY: 'The survey record is not valid.',
  CONTENT_HASH_MISMATCH: 'The record has changed since you opened it. Reload and decide again.',
  NOT_PENDING: 'The record is no longer waiting for this decision.',
  APPROVAL_RULE_MISSING: 'No approval rule applies to this record.',
  WORK_RECORD_REPORTED: 'A reported work record cannot be changed [NR496 4.5.3f].',
  RECORD_VOIDED: 'The record has been voided.',
  ALREADY_VOIDED: 'The record has already been voided.',
  VOID_REASON_REQUIRED: 'Write why the record is voided.',
  VOID_REQUIRES_VESSEL_SCOPE: 'Records are voided on board.',
  INVALID_RECORD_TYPE: 'The record type is not valid.',
  INVALID_CORRECTION: 'The correction is not valid.',
  EVIDENCE_MISMATCH: 'The attachments of the correction do not match. Reload and try again.',
  POSTPONEMENT_REASON_REQUIRED: 'Write why the job is postponed.',
  NEW_DUE_REQUIRED: 'Enter the new due date or running hours.',
  POSTPONEMENT_TRIGGER_MISMATCH: 'Postpone by the same trigger as the due date.',
  POSTPONEMENT_MUST_BE_LATER: 'The new due must be later than the current due.',
  POSTPONEMENT_MISMATCH: 'The postponement does not match the plan. Reload and try again.',
  // Ofisin erteleme notu ve kararı (ADR 0108 §3)
  OFFICE_ACTION_TEXT_REQUIRED: 'Write the comment or the reason.',
  INVALID_OFFICE_ACTION: 'The office action is invalid.',
  OFFICE_ACTION_PENDING: 'A decision on this postponement is still on its way to the vessel.',
  POSTPONEMENT_NOT_APPROVED: 'Only an approved postponement can be revoked or changed.',
  POSTPONEMENT_REVOKED: 'The postponement has already been revoked.',
  POSTPONEMENT_NOT_CURRENT:
    'The postponement is no longer in effect (the job was done or postponed again).',
  DUE_UNCHANGED: 'The new due is the same as the due in effect.',
  CLASS_REFERENCE_REQUIRED: 'A class item needs the class reference (surveyor approval).',
  INVALID_ATTACHMENT: 'The attachment is not valid.',
  INVALID_OWNER_TYPE: 'The attachment cannot be added here.',
  UNSUPPORTED_FILE_TYPE: 'Only JPEG, PNG or PDF files can be attached.',
  FILE_TOO_LARGE: 'The file is larger than 25 MB.',
  FILES_UNAVAILABLE: 'The file store of the ship server is not available.',
  FILE_NOT_ON_BOARD: 'The file is not on the ship server.',
  FILE_NOT_UPLOADED: 'The file has not reached the office yet.',
  // Ofisin aralık kararı (ADR 0104)
  DIRECT_EDIT_IN_SETUP: 'The vessel is in setup: correct the interval on the Job Card.',
  INTERVAL_CHANGE_PENDING:
    'An interval change proposed on board is waiting for the office decision. Decide it first.',
};

export const pmsWorkErrorsTr: typeof pmsWorkErrorsEn = {
  INVALID_PASSWORD: 'Parola yanlış.',
  INVALID_CREDENTIALS: 'Parola yanlış.',
  TOO_MANY_ATTEMPTS: 'Çok fazla deneme. Birkaç dakika bekleyip yeniden deneyin.',
  REAUTHENTICATION_REQUIRED: 'İmzalamak için parolanızı girin.',
  INVALID_JOB: 'Bazı iş alanları geçersiz.',
  DUPLICATE_JOB_CODE: 'Bu gemide aynı kodu kullanan başka bir iş var.',
  JOB_DELETED: 'İş silinmiş.',
  JOB_INACTIVE: 'İş etkin değil.',
  JOB_EQUIPMENT_FIXED: 'Var olan işin ekipmanı değiştirilemez.',
  JOB_EQUIPMENT_MISMATCH: 'İş başka bir ekipmana ait.',
  JOB_REQUIRED: 'Planlı iş emri bir işe bağlı olmalı.',
  JOB_NOT_ALLOWED: 'Plansız iş emri bir işe bağlanmaz.',
  COUNTER_REQUIRED: 'Saat aralığı için ekipmanda ya da üstünde çalışma saati sayacı olmalı.',
  COUNTER_NOT_ANCESTOR: 'Sayaç ekipmanın kendisinde ya da üstlerinden birinde olmalı.',
  COUNTER_LOCKED: 'İş kaydı girildikten sonra sayaç değiştirilemez.',
  BASELINE_LOCKED: 'İş kaydı girildikten sonra önceki sistemin kaydı değiştirilemez.',
  BASELINE_HOURS_REQUIRED: 'Son yapılıştaki çalışma saatini girin.',
  CLASS_INTERVAL_EXCEEDS_CMS: 'Klas kalemi en geç 60 ayda bir yapılmalı.',
  INVALID_INTERVAL: 'Aralık geçersiz.',
  INTERVAL_UNCHANGED: 'Yeni aralık güncel aralıkla aynı.',
  INTERVAL_CHANGE_REASON_REQUIRED: 'Aralığın neden değiştiğini yazın.',
  INTERVAL_CHANGE_REQUIRES_REQUEST: 'Bu işin kaydı var: aralık değişikliğini talep edin.',
  INTERVAL_BASIS_MAKER_REQUIRED:
    'Üretici aralığının ötesine uzatma klas ya da şirket dayanağı ister.',
  INTERVAL_MISMATCH: 'Aralık planla uyuşmuyor. Yenileyip yeniden deneyin.',
  DIRECTION_MISMATCH: 'Aralık değişikliği planla uyuşmuyor. Yenileyip yeniden deneyin.',
  UNKNOWN_CONDITION_POINT: 'Bir ölçüm noktası bulunamadı.',
  UNKNOWN_DOCUMENT: 'Bağlı doküman bulunamadı.',
  UNKNOWN_ROLE: 'Rol bulunamadı.',
  UNKNOWN_USER: 'Kişi bulunamadı.',
  UNKNOWN_MATERIAL: 'Bir parça stok listesinde bulunamadı.',
  PROVISION_NOT_SPARE_PART: 'Kumanya yedek parça olarak kullanılamaz. Kalemi listeden çıkarın.',
  UNKNOWN_DEFECT: 'Arıza bulunamadı.',
  INSTRUCTION_SECTION_MISMATCH: 'Talimat PMS Talimatları bölümünde bir doküman olmalı.',
  MANUAL_SECTION_MISMATCH: 'El kitabı Manuals bölümünde bir doküman olmalı.',
  INSTRUCTION_MISMATCH: 'İş emrinin talimatı uyuşmuyor. Yenileyip yeniden deneyin.',
  INVALID_WORK_ORDER: 'Bazı iş emri alanları geçersiz.',
  INVALID_TRANSITION: 'İş emri bu duruma geçemez.',
  OPEN_WORK_ORDER_EXISTS: 'Bu işin açık bir iş emri var.',
  WORK_ORDER_CANCELLED: 'İş emri iptal edilmiş.',
  WORK_ORDER_REPORTED: 'İş emri raporlanmış, değiştirilemez.',
  WORK_ORDER_ALREADY_REPORTED: 'İş emri zaten raporlanmış.',
  WORK_ORDER_FIXED: 'Bu iş emri alanları değiştirilemez.',
  WORK_ORDER_MISMATCH: 'Kayıt başka bir iş emrine ait.',
  WO_NO_MISMATCH: 'İş emri numarası uyuşmuyor. Yenileyip yeniden deneyin.',
  TARGET_ON_NOT_ALLOWED: 'Planlı iş emrinin vadesi plandan gelir.',
  CANCEL_REASON_REQUIRED: 'İş emrinin neden iptal edildiğini yazın.',
  HORIZON_OUT_OF_RANGE: '1 ile 365 gün arasında seçin.',
  SAFETY_CHECK_INCOMPLETE: 'Raporlamadan önce her güvenlik maddesini işaretleyin.',
  WORK_DESCRIPTION_REQUIRED: 'Yapılan işi yazın.',
  PERFORMER_REQUIRED: 'İşi yapan en az bir kişiyi yazın.',
  RESULT_REQUIRED: 'Sonucu seçin.',
  RESULT_INCONSISTENT: 'Kontrol listesinde başarısız madde varken sonuç başarılı olamaz.',
  CHECKLIST_INCOMPLETE: 'Kontrol listesinin her maddesini cevaplayın.',
  CHECKLIST_INVALID: 'Kontrol listesi cevapları işle uyuşmuyor.',
  CHECKLIST_VALUE_REQUIRED: 'Ölçülen her maddenin değerini girin.',
  CHECKLIST_REMARK_REQUIRED: 'Başarısız her madde için not yazın.',
  CONDITION_AFTER_REQUIRED: 'İşten sonra ekipmanın durumunu seçin.',
  OVERDUE_REASON_REQUIRED: 'İş gecikmiş: gecikmenin gerekçesini yazın.',
  CM_REPORT_REQUIRED:
    'Durum izleme raporunu ekleyin ya da servis sağlayıcının göndereceğini beyan edin.',
  CM_REPORT_NOT_PENDING: 'Bu kayda rapor yalnız sağlayıcıdan beklendiği beyan edildiyse eklenir.',
  INVALID_CONDITION: 'Durum geçersiz.',
  INVALID_WORK_HOURS: 'Adam-saat 0’dan büyük ve en çok 10.000 olmalı.',
  RUNNING_HOURS_REQUIRED: 'Bitişteki çalışma saatini girin.',
  RUNNING_HOURS_MISMATCH: 'Çalışma saati sayaçla uyuşmuyor.',
  HOURS_AFTER_CURRENT: 'Çalışma saati sayacın güncel değerinden büyük olamaz.',
  METER_EVENT_HAS_LATER_READINGS: 'Sayacın daha sonraki okumaları var.',
  INVALID_SPARE_PARTS: 'Kullanılan parçaları denetleyin.',
  DONE_ON_MISMATCH: 'Tarih gemi saatiyle uyuşmuyor. Yenileyip yeniden deneyin.',
  DUE_MISMATCH: 'Vade değişti. Yenileyip yeniden deneyin.',
  FIRST_ORIGINAL_DUE_MISMATCH: 'İlk orijinal vade değişti. Yenileyip yeniden deneyin.',
  CYCLE_MISMATCH: 'Plan değişti. Yenileyip yeniden deneyin.',
  CE_MISMATCH: 'Sörvey işareti işle uyuşmuyor.',
  INVALID_CE_COPY: 'Sörvey kaydı geçersiz.',
  CONTENT_HASH_MISMATCH: 'Kayıt siz açtıktan sonra değişti. Yenileyip yeniden karar verin.',
  NOT_PENDING: 'Kayıt artık bu kararı beklemiyor.',
  APPROVAL_RULE_MISSING: 'Bu kayda uyan bir onay kuralı yok.',
  WORK_RECORD_REPORTED: 'Raporlanmış iş kaydı değiştirilemez [NR496 4.5.3f].',
  RECORD_VOIDED: 'Kayıt iptal edilmiş.',
  ALREADY_VOIDED: 'Kayıt zaten iptal edilmiş.',
  VOID_REASON_REQUIRED: 'Kaydın neden iptal edildiğini yazın.',
  VOID_REQUIRES_VESSEL_SCOPE: 'Kayıtlar gemide iptal edilir.',
  INVALID_RECORD_TYPE: 'Kayıt türü geçersiz.',
  INVALID_CORRECTION: 'Düzeltme geçersiz.',
  EVIDENCE_MISMATCH: 'Düzeltmenin ekleri uyuşmuyor. Yenileyip yeniden deneyin.',
  POSTPONEMENT_REASON_REQUIRED: 'İşin neden ertelendiğini yazın.',
  NEW_DUE_REQUIRED: 'Yeni vade tarihini ya da saatini girin.',
  POSTPONEMENT_TRIGGER_MISMATCH: 'Vadeyle aynı tetikleyiciyle erteleyin.',
  POSTPONEMENT_MUST_BE_LATER: 'Yeni vade güncel vadeden sonra olmalı.',
  POSTPONEMENT_MISMATCH: 'Erteleme planla uyuşmuyor. Yenileyip yeniden deneyin.',
  OFFICE_ACTION_TEXT_REQUIRED: 'Yorumu ya da gerekçeyi yazın.',
  INVALID_OFFICE_ACTION: 'Ofis işlemi geçersiz.',
  OFFICE_ACTION_PENDING: 'Bu ertelemeye verilen bir karar hâlâ gemiye gidiyor.',
  POSTPONEMENT_NOT_APPROVED: 'Yalnız onaylanmış erteleme geri çevrilir ya da değiştirilir.',
  POSTPONEMENT_REVOKED: 'Erteleme zaten geri çevrildi.',
  POSTPONEMENT_NOT_CURRENT: 'Erteleme artık yürürlükte değil (iş yapıldı ya da yeniden ertelendi).',
  DUE_UNCHANGED: 'Yeni vade yürürlükteki vadeyle aynı.',
  CLASS_REFERENCE_REQUIRED: 'Klas kalemi klas referansı (sörveyör onayı) ister.',
  INVALID_ATTACHMENT: 'Ek geçersiz.',
  INVALID_OWNER_TYPE: 'Ek buraya eklenemez.',
  UNSUPPORTED_FILE_TYPE: 'Yalnız JPEG, PNG ya da PDF dosyası eklenebilir.',
  FILE_TOO_LARGE: 'Dosya 25 MB’tan büyük.',
  FILES_UNAVAILABLE: 'Gemi sunucusunun dosya deposu kullanılamıyor.',
  FILE_NOT_ON_BOARD: 'Dosya gemi sunucusunda yok.',
  FILE_NOT_UPLOADED: 'Dosya henüz ofise ulaşmadı.',
  DIRECT_EDIT_IN_SETUP: 'Gemi kurulum devrinde: aralığı Job Card’da düzeltin.',
  INTERVAL_CHANGE_PENDING:
    'Gemide önerilen aralık değişikliği ofis kararını bekliyor. Önce onu karara bağlayın.',
};

/** Form alanlarının ek hata kodları (domain şemaları). */
export const pmsWorkFieldErrorsEn = {
  INVALID_ID: 'Choose an option.',
  INVALID_LIST: 'The list is not valid.',
  INVALID_OBJECT: 'The value is not valid.',
  UNRECOGNIZED_KEY: 'The value is not valid.',
  TOO_MANY: 'Too many items.',
  INTERVAL_REQUIRED: 'Enter a calendar interval, running hours or both.',
  MAX_INTERVAL_REQUIRED: 'A condition based job also needs a calendar or running hour limit.',
  BASELINE_DATE_REQUIRED: 'Enter the date of the last time done.',
  NEW_DUE_REQUIRED: 'Enter the new due date or running hours.',
  POSTPONEMENT_MUST_BE_LATER: 'The new due must be later than the current due.',
  CLASS_REFERENCE_REQUIRED: 'A class item needs the class reference.',
  INTERVAL_UNCHANGED: 'The new interval is the same as the current one.',
  CLASS_INTERVAL_EXCEEDS_CMS: 'A class item must be done at least every 60 months.',
};

export const pmsWorkFieldErrorsTr: typeof pmsWorkFieldErrorsEn = {
  INVALID_ID: 'Bir seçenek seçin.',
  INVALID_LIST: 'Liste geçersiz.',
  INVALID_OBJECT: 'Değer geçersiz.',
  UNRECOGNIZED_KEY: 'Değer geçersiz.',
  TOO_MANY: 'Çok fazla madde.',
  INTERVAL_REQUIRED: 'Takvim aralığı, çalışma saati ya da ikisini girin.',
  MAX_INTERVAL_REQUIRED: 'Durum tetikli iş ayrıca takvim ya da saat üst sınırı ister.',
  BASELINE_DATE_REQUIRED: 'Son yapılış tarihini girin.',
  NEW_DUE_REQUIRED: 'Yeni vade tarihini ya da saatini girin.',
  POSTPONEMENT_MUST_BE_LATER: 'Yeni vade güncel vadeden sonra olmalı.',
  CLASS_REFERENCE_REQUIRED: 'Klas kalemi klas referansı ister.',
  INTERVAL_UNCHANGED: 'Yeni aralık güncel aralıkla aynı.',
  CLASS_INTERVAL_EXCEEDS_CMS: 'Klas kalemi en geç 60 ayda bir yapılmalı.',
};

export const pmsWorkEn = {
  vessel: 'Vessel',
  loadError: 'The maintenance data could not be loaded.',
  showing: 'Showing {{from}}–{{to}} of {{total}}',
  pages: '{{name}} pages',
  close: 'Close',
  clear: 'Clear',
  frequency: {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    annual: 'Annual',
    every: {
      day_one: 'Every {{count}} day',
      day_other: 'Every {{count}} days',
      week_one: 'Every {{count}} week',
      week_other: 'Every {{count}} weeks',
      month_one: 'Every {{count}} month',
      month_other: 'Every {{count}} months',
      year_one: 'Every {{count}} year',
      year_other: 'Every {{count}} years',
    },
    hours: '{{hours}} h',
    condition: 'Condition based',
  },
  status: {
    on_time: 'On Time',
    due_soon: 'Due Soon',
    overdue: 'Overdue',
    postponed: 'Postponed',
    scheduled: 'Scheduled',
    planned: 'Planned',
    in_progress: 'In Progress',
    completed: 'Completed',
    pending: 'Pending',
    returned: 'Returned',
    cancelled: 'Cancelled',
    voided: 'VOID',
    approved: 'Approved',
  },
  priority: { low: 'Low', medium: 'Medium', high: 'High' },
  // Bakım kategorisi (DNV-CP-0206 Sec.2 [4.3] e; ADR 0133 §1)
  categories: { preventive: 'Preventive (planned)', corrective: 'Corrective (unplanned)' },
  workTypes: {
    Inspection: 'Inspection',
    Overhaul: 'Overhaul',
    Service: 'Service',
    Cleaning: 'Cleaning',
    Replace: 'Replace',
    Test: 'Test',
    Calibration: 'Calibration',
    Lubrication: 'Lubrication',
    // ISO 14224 Table B.5 (DNV-CP-0206 Sec.2 [4.3] f; ADR 0133 §4)
    Repair: 'Repair',
    Modify: 'Modify',
    Adjust: 'Adjust',
    Refit: 'Refit',
    Check: 'Check',
    Combination: 'Combination',
    Other: 'Other',
  },
  jobTypes: {
    preventive: 'Preventive',
    inspection: 'Inspection',
    test: 'Test',
    condition_based: 'Condition based',
    class_survey: 'Class survey',
  },
  bases: { maker: 'Maker', class: 'Class', experience: 'Experience', company: 'Company' },
  units: { day: 'Days', week: 'Weeks', month: 'Months', year: 'Years' },
  results: { pass: 'Pass', fail: 'Fail' },
  password: {
    back: 'Back',
    reason: 'Reason',
    password: 'Password',
    hint: 'Enter your password again to sign.',
  },
  plan: {
    description: 'Due dates, postponements and the job library of the vessel.',
    tabs: { plan: 'Plan', jobs: 'Job Library', instructions: 'Instructions' },
    flags: {
      label: 'Show only',
      critical: 'Critical',
      class: 'Class items',
      alarmTest: 'Alarm tests (UMS)',
      overdue: 'Overdue',
      postponed: 'Postponed',
    },
    openJob: '{{code}}: open the Job Card of {{name}}',
    postponementPending: 'Postponement pending',
    intervalPending: 'Interval change pending',
    more: 'More actions for {{code}}',
    openWorkOrder: 'Open Work Order {{no}}',
    view: 'View Job Card',
    postpone: 'Postpone',
  },
  job: {
    title: 'Job Card · {{code}}',
    new: 'New Job',
    sections: {
      identity: 'Job',
      interval: 'Interval',
      procedure: 'Procedure',
      checklist: 'Checklist',
      safety: 'Safety and acceptance',
      documents: 'Instruction and manual',
      baseline: 'Last done in the previous system',
    },
    code: 'Job Code',
    equipment: 'Equipment',
    jobTitle: 'Task',
    workType: 'Work Type',
    jobType: 'Task Type',
    priority: 'Priority',
    calendarEvery: 'Every',
    calendarUnit: 'Unit',
    runningHours: 'Running hours',
    intervalBasis: 'Interval basis',
    estimatedMinutes: 'Estimated duration (min)',
    changeReason: 'Reason for the interval correction',
    changeReasonHint: 'No work is recorded yet: the interval is corrected directly with a reason.',
    intervalLocked:
      'Work has been recorded: the interval changes only by request (extension needs office approval).',
    requestInterval: 'Request interval change',
    officeInterval: 'Change interval',
    officeIntervalHint:
      'The office sets the interval. The vessel applies it at the next synchronisation.',
    officeIntervalBlocked:
      'An interval change proposed on board is waiting for your decision. Decide it first.',
    step: 'Step {{n}}',
    removeStep: 'Remove step {{n}}',
    addStep: 'Add step',
    checkItem: 'Checklist item {{n}}',
    checkKind: 'Answer type of item {{n}}',
    checkUnit: 'Unit of item {{n}}',
    unit: 'Unit',
    removeCheck: 'Remove checklist item {{n}}',
    addCheck: 'Add checklist item',
    kinds: { check: 'Check', value: 'Value' },
    safetyItem: 'Safety item {{n}}',
    removeSafety: 'Remove safety item {{n}}',
    addSafety: 'Add safety item',
    acceptance: 'Acceptance criteria',
    instruction: 'PMS instruction',
    manualRef: 'Manual reference',
    ceSurvey: 'Chief Engineer survey item (class)',
    alarmTest: 'Alarm test (UMS / E0–ECO)',
    alarmTestHint:
      'Testing of alarms for periodically unattended machinery spaces (DNV-RU-SHIP Pt.6 Ch.2 Sec.2 [3]).',
    baselineHint:
      'Enter the last time the job was done before Felixmate; the first due date is calculated from it.',
    baselineDoneOn: 'Last done on',
    baselineDoneHours: 'Running hours when done',
  },
  postpone: {
    title: 'Postpone {{code}}',
    submit: 'Send for approval',
    job: 'Job',
    component: 'Component',
    currentDue: 'Current due',
    firstOriginalDue: 'First original due',
    hint: 'The due date changes when the Master approves; the approval ends on board and the office can see it. The first original due stays on record.',
    newDueOn: 'New due date',
    newDueHours: 'New due running hours',
    reason: 'Reason',
    classReference: 'Class reference',
    classReferenceRequired: 'Class item: enter the surveyor approval reference.',
    classReferenceHint: 'Optional for non-class items.',
  },
  interval: {
    title: 'Request interval change · {{code}}',
    submit: 'Send request',
    current: 'Current interval',
    hint: 'A shorter interval applies at once. An extension waits for the office approval.',
    reason: 'Reason',
    classReference: 'Class reference',
    // Ofisin aralık kararı (ADR 0104 §7)
    officeTitle: 'Change interval · {{code}}',
    officeSubmit: 'Send to vessel',
    officeHint:
      'The vessel applies the new interval at the next synchronisation, without approval on board. Condition triggers stay as set on board.',
    sent: 'Sent to vessel. It applies at the next synchronisation.',
  },
  // İşin değişiklik kaydı (DNV-CP-0206 Sec.2 [4.6] b; ADR 0133 §2)
  changeLog: {
    title: 'Change Log (interval and instructions)',
    unknownUser: 'Unknown user',
    vesselRole: '{{role}}',
    officeRole: '{{role}} (office)',
    noRole: 'No role on that day',
    kinds: {
      created: 'Created',
      interval: 'Interval',
      instruction: 'Instructions',
      interval_instruction: 'Interval and instructions',
    },
    fields: {
      interval_every: 'Interval (calendar)',
      interval_unit: 'Interval unit',
      interval_hours: 'Interval (running hours)',
      interval_basis: 'Interval basis',
      counter_equipment_id: 'Running hour counter',
      condition_point_ids: 'Condition triggers',
      procedure: 'Procedure',
      checklist: 'Checklist',
      safety_items: 'Safety items',
      acceptance_criteria: 'Acceptance criteria',
      instruction_document_id: 'Work instruction',
      manual_document_id: 'Manual',
      manual_ref: 'Manual reference',
    },
  },
  intervalHistory: {
    title: 'Interval history',
    date: 'Date',
    change: 'Interval',
    source: 'Source',
    basis: 'Basis',
    reason: 'Reason',
    by: 'By',
    status: 'Status',
    sources: { ship: 'Ship', office: 'Office' },
    statuses: {
      effective: 'Applied',
      pending: 'Pending approval',
      returned: 'Returned',
      sent: 'Sent to vessel',
      rejected: 'Not applied on board',
    },
    office: 'Office',
    classReference: 'Class ref. {{ref}}',
  },
  decision: {
    panel: 'Pending Decisions',
    review: 'Review',
    kind: {
      postponement: 'Postponement',
      interval: 'Interval change',
      record: 'Work record',
      defect: 'Defect closure',
      breakdown: 'Breakdown closure',
    },
    title: {
      postponement: 'Postponement request',
      interval: 'Interval change request',
      record: 'Work record approval',
      defect: 'Defect closure approval',
      breakdown: 'Breakdown closure approval',
    },
    step: {
      office: 'Office step {{step}}: the superintendent decides.',
      ship: 'Step {{step}} on board: the Master decides.',
    },
    job: 'Job',
    component: 'Component',
    currentDue: 'Current due',
    newDue: 'Requested due',
    firstOriginalDue: 'First original due',
    previousInterval: 'Current interval',
    newInterval: 'Requested interval',
    direction: 'Change',
    directions: { extend: 'Extension', shorten: 'Shortening' },
    basis: 'Interval basis',
    doneOn: 'Done on',
    result: 'Result',
    workPerformed: 'Work performed',
    reason: 'Reason',
    classReference: 'Class reference',
    since: 'Waiting since',
    approve: 'Approve',
    return: 'Return',
    approveTitle: 'Approve',
    returnTitle: 'Return for correction',
    approveBody: 'You approve the {{name}} as shown. Your approval carries the content hash.',
    returnBody: 'The {{name}} goes back to the sender with your reason.',
  },
  workOrders: {
    description: 'Planned and unplanned work orders, reporting and approval.',
    statusFilter: 'Status',
    equipmentFilter: 'Machinery item',
    categoryFilter: 'Category',
    activityFilter: 'Activity',
    filters: {
      all: 'All',
      open: 'Open',
      pending: 'Pending',
      completed: 'Completed',
      returned: 'Returned',
      cancelled: 'Cancelled',
    },
  },
  generate: {
    title: 'Generate Work Orders',
    body: 'Opens one work order for each job due within {{days}} days or overdue that has no open work order.',
    horizon: 'Horizon (days)',
    submit: 'Generate',
    done_one: '{{count}} work order opened.',
    done_other: '{{count}} work orders opened.',
  },
  newWorkOrder: {
    title: 'New Work Order',
    mode: 'Work order type',
    fromJob: 'From maintenance job',
    unplanned: 'Unplanned work',
    job: 'Job',
    equipment: 'Equipment',
    kind: 'Kind',
    task: 'Task',
    priority: 'Priority',
    targetOn: 'Target date',
    assignedTo: 'Assigned To',
    submit: 'Open Work Order',
  },
  detail: {
    back: 'Work Orders',
    stepsLabel: 'Work order progress',
    steps: {
      assigned: 'Assigned',
      started: 'Started',
      safetyCheck: 'Safety Check',
      maintenance: 'Maintenance',
      measurements: 'Measurements',
      spareParts: 'Spare Parts',
      photos: 'Photos',
      completed: 'Completed',
      approval: 'Chief Engineer Approval',
      closed: 'Closed',
    },
    tabs: {
      safety: 'Safety Check',
      maintenance: 'Maintenance',
      measurements: 'Measurements',
      spareParts: 'Spare Parts',
      photos: 'Photos',
      remarks: 'Remarks',
    },
    readOnly:
      'This record has been reported and cannot be changed. A correction voids it with a reason and enters a new record.',
    officeReadOnly: 'Work records are entered on board; the office sees them read-only.',
    measurementsEmpty: 'No measurement points are defined for this job.',
    remarks: 'Remarks',
    start: 'Start Work',
    // Bakım sırasında arıza (LGS-17; ADR 0096 §6)
    reportDefect: 'Report Defect',
    saveDraft: 'Save Draft',
    draftSaved: 'Draft saved on this computer.',
    complete: 'Complete & Report',
    reported: 'Work record reported. It now waits for approval.',
    reportTitle: 'Complete & Report',
    reportBody:
      'You are signing the work record of {{wo}}. Once reported it cannot be changed; corrections are made by voiding it with a reason.',
    summary: 'Work Order Summary',
    fields: {
      woNo: 'WO No',
      kind: 'Kind',
      job: 'Job',
      component: 'Component',
      dueDate: 'Due Date',
      dueHours: 'Due running hours',
      assignedTo: 'Assigned To',
      startedAt: 'Started',
    },
    kinds: {
      planned: 'Planned',
      unplanned: 'Unplanned',
      corrective: 'Corrective',
      breakdown: 'Breakdown',
    },
    instruction: {
      title: 'Instruction',
      none: 'No instruction is linked to this job.',
      missing: 'Instruction not on board',
      missingHint:
        'The instruction in force has not reached the ship server yet. Do the work after it arrives or follow the master copy.',
      onBoard: 'On board',
      superseded: 'A newer revision has come into force since this work order was opened.',
      viewManual: 'View Manual',
    },
    safetyNone: 'This job has no safety items.',
    safetyHint: 'Tick each item before starting the work. All items must be ticked to report.',
    maintenance: {
      doneAt: 'Done at (ship time)',
      meterHours: 'Running hours at completion',
      performedBy: 'Performed by',
      performer: 'Person {{n}}',
      removePerformer: 'Remove person {{n}}',
      addPerformer: 'Add person',
      workPerformed: 'Work performed',
      checklist: 'Checklist',
      checklistNone: 'This job has no checklist.',
      answers: { pass: 'Pass', fail: 'Fail', na: 'N/A' },
      answerOf: 'Answer: {{item}}',
      valueOf: 'Value: {{item}}',
      value: 'Value',
      remarkOf: 'Remark: {{item}}',
      remark: 'Remark',
      result: 'Result',
      conditionAfter: 'Condition after work',
      conditionBefore: 'Condition before work',
      workHours: 'Actual man-hours',
      optional: 'Optional',
      overdueReason: 'Reason for overdue',
      overdueHint:
        'The job is reported after its due date or due running hours. Write why it was delayed.',
    },
    cmReport: {
      title: 'Condition monitoring report',
      hint: 'Condition based job: attach the diagnostic or prognostic report (PDF) in this step, or confirm that the service supplier will send it.',
      attached: 'The report is attached to the work order.',
      pending: 'Report will be provided by the service supplier',
      awaited: 'The report has not been received yet. Attach it when it arrives.',
      received: 'Report received later',
      upload: 'Attach received report',
    },
    dismiss: 'Dismiss',
    spareParts: {
      none: 'No parts used.',
      hint: 'Parts used are taken out of the vessel stock when the work is reported.',
      part: 'Part {{n}}',
      nothingFound: 'No spare part matches; provisions are not listed here.',
      onHand: 'On hand: {{qty}} {{unit}}',
      quantity: 'Quantity of part {{n}}',
      remove: 'Remove part {{n}}',
      add: 'Add part',
    },
    photos: {
      upload: 'Upload photo or PDF',
      hint: 'JPEG, PNG or PDF up to 25 MB; photos are reduced before upload.',
    },
  },
  attachments: {
    title: 'Attachments',
    none: 'No attachments yet.',
    kinds: { photo: 'Photo', report: 'Report', other: 'Other' },
    uploading: 'Uploading from vessel',
    onVessel: 'File on vessel',
    voided: 'Voided',
  },
  approval: {
    title: 'Chief Engineer Approval',
    pending: 'Waiting for approval (step {{step}})',
    officeStep: 'Waiting for the office (step {{step}})',
    approved: 'Approved',
    returned: 'Returned for correction',
    reportedBy: 'Reported by {{name}} on {{at}}',
  },
  void: {
    void: 'Void',
    correct: 'Correct',
    voidTitle: 'Void work record · {{wo}}',
    correctTitle: 'Correct work record · {{wo}}',
    voidBody: 'The record stays in the history marked VOID with your reason [NR496 4.5.3f].',
    correctBody:
      'The record is voided with your reason and the corrected record is reported in the same step.',
    reason: 'Reason',
    submitCorrection: 'Void and report correction',
    voidNote:
      'You are voiding this record. Your name, the time and the reason are recorded with it.',
    correctNote:
      'You are voiding this record and reporting the correction. Your name, the time and the reason are recorded with it.',
    correcting: 'Correcting {{wo}}: change the values and report the new record.',
  },
  history: {
    title: 'Work Records',
    description: 'Reported maintenance records of the vessel, including voided ones.',
    tabs: { records: 'Work History', reports: 'Reports', audit: 'Audit Trail' },
    auditFiltered: 'Only the changes of the selected {{record}} are shown.',
    auditAll: 'Show all changes',
    filters: {
      equipment: 'Equipment',
      job: 'Job',
      from: 'From',
      to: 'To',
      performer: 'Performed by',
      category: 'Category',
      activity: 'Activity',
      all: 'All',
    },
    removed: '(removed)',
    columns: {
      doneOn: 'Done On',
      woNo: 'WO No',
      equipment: 'Component',
      job: 'Job',
      performedBy: 'Performed By',
      status: 'Status',
    },
    superseded: 'Superseded after return',
    voidReason: 'Void reason: {{reason}}',
    replacedBy: 'Replaced by the record of {{date}}',
    correction: 'Correction of a voided record',
    empty: 'No work records yet',
    noMatch: 'No records match the filters.',
  },
  bell: {
    title: 'Maintenance decisions',
    record: 'Work record waiting for your approval',
    postponement: 'Postponement waiting for your decision',
    interval: 'Interval change waiting for your decision',
    defect: 'Defect closure waiting for your approval',
    breakdown: 'Breakdown closure waiting for your approval',
  },
  library: {
    title: 'Job Library',
    alarmTestBadge: 'Alarm test',
    search: 'Search job, code, component...',
    empty: 'No maintenance jobs yet',
    emptyHint: 'Define the jobs of the vessel: interval, procedure and checklist.',
    noMatch: 'No jobs match the search.',
    inactive: 'Inactive',
    columns: {
      code: 'Code',
      title: 'Job',
      component: 'Component',
      workType: 'Work Type',
      frequency: 'Frequency',
      lastDone: 'Last Done',
      nextDue: 'Next Due',
      status: 'Status',
    },
  },
};

export const pmsWorkTr: typeof pmsWorkEn = {
  vessel: 'Gemi',
  loadError: 'Bakım verisi okunamadı.',
  showing: '{{total}} kayıttan {{from}}–{{to}}',
  pages: '{{name}} sayfaları',
  close: 'Kapat',
  clear: 'Temizle',
  frequency: {
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    annual: 'Yıllık',
    every: {
      day_one: '{{count}} günde bir',
      day_other: '{{count}} günde bir',
      week_one: '{{count}} haftada bir',
      week_other: '{{count}} haftada bir',
      month_one: '{{count}} ayda bir',
      month_other: '{{count}} ayda bir',
      year_one: '{{count}} yılda bir',
      year_other: '{{count}} yılda bir',
    },
    hours: '{{hours}} sa',
    condition: 'Durum tetikli',
  },
  status: {
    on_time: 'Zamanında',
    due_soon: 'Yaklaşıyor',
    overdue: 'Gecikmiş',
    postponed: 'Ertelendi',
    scheduled: 'Planlandı',
    planned: 'Planlı',
    in_progress: 'Sürüyor',
    completed: 'Tamamlandı',
    pending: 'Onay bekliyor',
    returned: 'İade edildi',
    cancelled: 'İptal',
    voided: 'İPTAL',
    approved: 'Onaylandı',
  },
  priority: { low: 'Düşük', medium: 'Orta', high: 'Yüksek' },
  categories: { preventive: 'Önleyici (planlı)', corrective: 'Düzeltici (plansız)' },
  workTypes: {
    Inspection: 'Muayene',
    Overhaul: 'Revizyon',
    Service: 'Servis',
    Cleaning: 'Temizlik',
    Replace: 'Değişim',
    Test: 'Test',
    Calibration: 'Kalibrasyon',
    Lubrication: 'Yağlama',
    Repair: 'Onarım',
    Modify: 'Tadilat',
    Adjust: 'Ayar',
    Refit: 'Yeniden takma',
    Check: 'Kontrol',
    Combination: 'Birleşik',
    Other: 'Diğer',
  },
  jobTypes: {
    preventive: 'Önleyici',
    inspection: 'Muayene',
    test: 'Test',
    condition_based: 'Durum tetikli',
    class_survey: 'Klas sörveyi',
  },
  bases: { maker: 'Üretici', class: 'Klas', experience: 'Deneyim', company: 'Şirket' },
  units: { day: 'Gün', week: 'Hafta', month: 'Ay', year: 'Yıl' },
  results: { pass: 'Başarılı', fail: 'Başarısız' },
  password: {
    back: 'Geri',
    reason: 'Gerekçe',
    password: 'Parola',
    hint: 'İmzalamak için parolanızı yeniden girin.',
  },
  plan: {
    description: 'Geminin vadeleri, ertelemeleri ve görev kütüphanesi.',
    tabs: { plan: 'Plan', jobs: 'Görev Kütüphanesi', instructions: 'Talimatlar' },
    flags: {
      label: 'Yalnız göster',
      critical: 'Kritik',
      class: 'Klas kalemleri',
      alarmTest: 'Alarm testleri (UMS)',
      overdue: 'Gecikmiş',
      postponed: 'Ertelenmiş',
    },
    openJob: '{{code}}: {{name}} Job Card’ını aç',
    postponementPending: 'Erteleme bekliyor',
    intervalPending: 'Aralık değişikliği bekliyor',
    more: '{{code}} için diğer eylemler',
    openWorkOrder: '{{no}} İş Emrini Aç',
    view: 'Job Card’ı görüntüle',
    postpone: 'Ertele',
  },
  job: {
    title: 'Job Card · {{code}}',
    new: 'Yeni İş',
    sections: {
      identity: 'İş',
      interval: 'Aralık',
      procedure: 'Prosedür',
      checklist: 'Kontrol listesi',
      safety: 'Güvenlik ve kabul',
      documents: 'Talimat ve el kitabı',
      baseline: 'Önceki sistemde son yapılış',
    },
    code: 'İş Kodu',
    equipment: 'Ekipman',
    jobTitle: 'İş',
    workType: 'İş Türü',
    jobType: 'İş Sınıfı',
    priority: 'Öncelik',
    calendarEvery: 'Her',
    calendarUnit: 'Birim',
    runningHours: 'Çalışma saati',
    intervalBasis: 'Aralığın dayanağı',
    estimatedMinutes: 'Tahmini süre (dk)',
    changeReason: 'Aralık düzeltmesinin gerekçesi',
    changeReasonHint: 'Henüz iş kaydı yok: aralık gerekçeyle doğrudan düzeltilir.',
    intervalLocked: 'İş kaydı var: aralık yalnız taleple değişir (uzatma ofis onayı ister).',
    requestInterval: 'Aralık değişikliği talep et',
    officeInterval: 'Aralığı değiştir',
    officeIntervalHint: 'Aralığı ofis belirler. Gemi yeni aralığı ilk senkronda uygular.',
    officeIntervalBlocked:
      'Gemide önerilen aralık değişikliği kararınızı bekliyor. Önce onu karara bağlayın.',
    step: '{{n}}. adım',
    removeStep: '{{n}}. adımı kaldır',
    addStep: 'Adım ekle',
    checkItem: 'Kontrol maddesi {{n}}',
    checkKind: '{{n}}. maddenin cevap türü',
    checkUnit: '{{n}}. maddenin birimi',
    unit: 'Birim',
    removeCheck: '{{n}}. kontrol maddesini kaldır',
    addCheck: 'Kontrol maddesi ekle',
    kinds: { check: 'İşaret', value: 'Değer' },
    safetyItem: 'Güvenlik maddesi {{n}}',
    removeSafety: '{{n}}. güvenlik maddesini kaldır',
    addSafety: 'Güvenlik maddesi ekle',
    acceptance: 'Kabul ölçütü',
    instruction: 'PMS talimatı',
    manualRef: 'El kitabı referansı',
    ceSurvey: 'Başmühendis sörvey kalemi (klas)',
    alarmTest: 'Alarm testi (UMS / E0–ECO)',
    alarmTestHint:
      'Periyodik insansız makine dairesi alarmlarının testi (DNV-RU-SHIP Pt.6 Ch.2 Sec.2 [3]).',
    baselineHint:
      'İşin Felixmate’dan önce son yapıldığı zamanı girin; ilk vade buradan hesaplanır.',
    baselineDoneOn: 'Son yapılış tarihi',
    baselineDoneHours: 'Yapıldığındaki çalışma saati',
  },
  postpone: {
    title: '{{code}} ertele',
    submit: 'Onaya gönder',
    job: 'İş',
    component: 'Bileşen',
    currentDue: 'Güncel vade',
    firstOriginalDue: 'İlk orijinal vade',
    hint: 'Vade kaptan onaylayınca değişir; onay gemide biter, ofis görür. İlk orijinal vade kayıtta kalır.',
    newDueOn: 'Yeni vade tarihi',
    newDueHours: 'Yeni vade çalışma saati',
    reason: 'Gerekçe',
    classReference: 'Klas referansı',
    classReferenceRequired: 'Klas kalemi: sörveyör onayının referansını girin.',
    classReferenceHint: 'Klas kalemi olmayan işte isteğe bağlı.',
  },
  interval: {
    title: 'Aralık değişikliği talebi · {{code}}',
    submit: 'Talebi gönder',
    current: 'Güncel aralık',
    hint: 'Kısaltma hemen uygulanır. Uzatma ofis onayını bekler.',
    reason: 'Gerekçe',
    classReference: 'Klas referansı',
    officeTitle: 'Aralığı değiştir · {{code}}',
    officeSubmit: 'Gemiye gönder',
    officeHint:
      'Gemi yeni aralığı ilk senkronda, gemide onay beklemeden uygular. Durum tetikleyicileri gemideki gibi kalır.',
    sent: 'Gemiye gönderildi. İlk senkronda uygulanır.',
  },
  changeLog: {
    title: 'Değişiklik Kaydı (aralık ve talimat)',
    unknownUser: 'Bilinmeyen kullanıcı',
    vesselRole: '{{role}}',
    officeRole: '{{role}} (ofis)',
    noRole: 'O gün rolü yok',
    kinds: {
      created: 'Açıldı',
      interval: 'Aralık',
      instruction: 'Talimat',
      interval_instruction: 'Aralık ve talimat',
    },
    fields: {
      interval_every: 'Aralık (takvim)',
      interval_unit: 'Aralık birimi',
      interval_hours: 'Aralık (çalışma saati)',
      interval_basis: 'Aralığın dayanağı',
      counter_equipment_id: 'Çalışma saati sayacı',
      condition_point_ids: 'Durum tetikleri',
      procedure: 'Yöntem',
      checklist: 'Kontrol listesi',
      safety_items: 'Güvenlik maddeleri',
      acceptance_criteria: 'Kabul ölçütü',
      instruction_document_id: 'İş talimatı',
      manual_document_id: 'Kılavuz',
      manual_ref: 'Kılavuz referansı',
    },
  },
  intervalHistory: {
    title: 'Aralık geçmişi',
    date: 'Tarih',
    change: 'Aralık',
    source: 'Kaynak',
    basis: 'Dayanak',
    reason: 'Gerekçe',
    by: 'Giren',
    status: 'Durum',
    sources: { ship: 'Gemi', office: 'Ofis' },
    statuses: {
      effective: 'Uygulandı',
      pending: 'Onay bekliyor',
      returned: 'İade edildi',
      sent: 'Gemiye gönderildi',
      rejected: 'Gemide uygulanamadı',
    },
    office: 'Ofis',
    classReference: 'Klas ref. {{ref}}',
  },
  decision: {
    panel: 'Bekleyen Kararlar',
    review: 'İncele',
    kind: {
      postponement: 'Erteleme',
      interval: 'Aralık değişikliği',
      record: 'İş kaydı',
      defect: 'Arıza kapanışı',
      breakdown: 'Breakdown kapanışı',
    },
    title: {
      postponement: 'Erteleme talebi',
      interval: 'Aralık değişikliği talebi',
      record: 'İş kaydı onayı',
      defect: 'Arıza kapanış onayı',
      breakdown: 'Breakdown kapanış onayı',
    },
    step: {
      office: 'Ofis adımı {{step}}: süperintendent karar verir.',
      ship: 'Gemide {{step}}. adım: kaptan karar verir.',
    },
    job: 'İş',
    component: 'Bileşen',
    currentDue: 'Güncel vade',
    newDue: 'İstenen vade',
    firstOriginalDue: 'İlk orijinal vade',
    previousInterval: 'Güncel aralık',
    newInterval: 'İstenen aralık',
    direction: 'Değişiklik',
    directions: { extend: 'Uzatma', shorten: 'Kısaltma' },
    basis: 'Aralığın dayanağı',
    doneOn: 'Yapılış günü',
    result: 'Sonuç',
    workPerformed: 'Yapılan iş',
    reason: 'Gerekçe',
    classReference: 'Klas referansı',
    since: 'Bekleme başlangıcı',
    approve: 'Onayla',
    return: 'İade et',
    approveTitle: 'Onayla',
    returnTitle: 'Düzeltmeye iade et',
    approveBody: '{{name}} gösterildiği gibi onaylıyorsunuz. Onayınız içerik hash’ini taşır.',
    returnBody: '{{name}} gerekçenizle gönderene geri döner.',
  },
  workOrders: {
    description: 'Planlı ve plansız iş emirleri, raporlama ve onay.',
    statusFilter: 'Durum',
    equipmentFilter: 'Makine kalemi',
    categoryFilter: 'Kategori',
    activityFilter: 'Etkinlik',
    filters: {
      all: 'Tümü',
      open: 'Açık',
      pending: 'Onay bekleyen',
      completed: 'Tamamlanan',
      returned: 'İade edilen',
      cancelled: 'İptal',
    },
  },
  generate: {
    title: 'İş Emirlerini Oluştur',
    body: 'Vadesi {{days}} gün içinde olan ya da gecikmiş ve açık iş emri olmayan her işe bir iş emri açar.',
    horizon: 'Ufuk (gün)',
    submit: 'Oluştur',
    done_one: '{{count}} iş emri açıldı.',
    done_other: '{{count}} iş emri açıldı.',
  },
  newWorkOrder: {
    title: 'Yeni İş Emri',
    mode: 'İş emri türü',
    fromJob: 'Bakım işinden',
    unplanned: 'Plansız iş',
    job: 'İş',
    equipment: 'Ekipman',
    kind: 'Tür',
    task: 'Görev',
    priority: 'Öncelik',
    targetOn: 'Hedef tarih',
    assignedTo: 'Atanan',
    submit: 'İş Emrini Aç',
  },
  detail: {
    back: 'İş Emirleri',
    stepsLabel: 'İş emrinin ilerleyişi',
    steps: {
      assigned: 'Atandı',
      started: 'Başladı',
      safetyCheck: 'Güvenlik Kontrolü',
      maintenance: 'Bakım',
      measurements: 'Ölçümler',
      spareParts: 'Yedek Parça',
      photos: 'Fotoğraflar',
      completed: 'Tamamlandı',
      approval: 'Başmühendis Onayı',
      closed: 'Kapandı',
    },
    tabs: {
      safety: 'Güvenlik Kontrolü',
      maintenance: 'Bakım',
      measurements: 'Ölçümler',
      spareParts: 'Yedek Parça',
      photos: 'Fotoğraflar',
      remarks: 'Notlar',
    },
    readOnly:
      'Bu kayıt raporlandı, değiştirilemez. Düzeltme kaydı gerekçeyle iptal eder ve yeni kayıt girer.',
    officeReadOnly: 'İş kayıtları gemide girilir; ofis salt okunur görür.',
    measurementsEmpty: 'Bu iş için ölçüm noktası tanımlı değil.',
    remarks: 'Notlar',
    start: 'İşe Başla',
    reportDefect: 'Arıza Bildir',
    saveDraft: 'Taslağı Kaydet',
    draftSaved: 'Taslak bu bilgisayara kaydedildi.',
    complete: 'Tamamla ve Raporla',
    reported: 'İş kaydı raporlandı. Şimdi onay bekliyor.',
    reportTitle: 'Tamamla ve Raporla',
    reportBody:
      '{{wo}} iş kaydını imzalıyorsunuz. Raporlandıktan sonra değiştirilemez; düzeltme gerekçeli iptalle yapılır.',
    summary: 'İş Emri Özeti',
    fields: {
      woNo: 'İE No',
      kind: 'Tür',
      job: 'İş',
      component: 'Bileşen',
      dueDate: 'Vade',
      dueHours: 'Vade çalışma saati',
      assignedTo: 'Atanan',
      startedAt: 'Başlangıç',
    },
    kinds: {
      planned: 'Planlı',
      unplanned: 'Plansız',
      corrective: 'Düzeltici',
      breakdown: 'Arıza',
    },
    instruction: {
      title: 'Talimat',
      none: 'Bu işe bağlı talimat yok.',
      missing: 'Talimat gemide yok',
      missingHint:
        'Yürürlükteki talimat henüz gemi sunucusuna ulaşmadı. İşi talimat gelince yapın ya da ana kopyayı izleyin.',
      onBoard: 'Gemide',
      superseded: 'İş emri açıldıktan sonra yeni bir revizyon yürürlüğe girdi.',
      viewManual: 'El Kitabını Aç',
    },
    safetyNone: 'Bu işin güvenlik maddesi yok.',
    safetyHint:
      'İşe başlamadan her maddeyi işaretleyin. Raporlamak için bütün maddeler işaretli olmalı.',
    maintenance: {
      doneAt: 'Yapılış anı (gemi saati)',
      meterHours: 'Bitişteki çalışma saati',
      performedBy: 'Uygulayanlar',
      performer: 'Kişi {{n}}',
      removePerformer: '{{n}}. kişiyi kaldır',
      addPerformer: 'Kişi ekle',
      workPerformed: 'Yapılan iş',
      checklist: 'Kontrol listesi',
      checklistNone: 'Bu işin kontrol listesi yok.',
      answers: { pass: 'Uygun', fail: 'Uygun değil', na: 'Yok' },
      answerOf: 'Cevap: {{item}}',
      valueOf: 'Değer: {{item}}',
      value: 'Değer',
      remarkOf: 'Not: {{item}}',
      remark: 'Not',
      result: 'Sonuç',
      conditionAfter: 'İşten sonraki durum',
      conditionBefore: 'İşten önceki durum',
      workHours: 'Gerçek adam-saat',
      optional: 'İsteğe bağlı',
      overdueReason: 'Gecikme gerekçesi',
      overdueHint:
        'İş vade tarihinden ya da vade saatinden sonra raporlanıyor. Neden geciktiğini yazın.',
    },
    cmReport: {
      title: 'Durum izleme raporu',
      hint: 'Durum bazlı iş: tanı ya da öngörü raporunu (PDF) bu adımda ekleyin ya da servis sağlayıcının göndereceğini beyan edin.',
      attached: 'Rapor iş emrine eklendi.',
      pending: 'Rapor servis sağlayıcıdan bekleniyor',
      awaited: 'Rapor henüz gelmedi. Gelince ekleyin.',
      received: 'Sonradan gelen rapor',
      upload: 'Gelen raporu ekle',
    },
    dismiss: 'Kapat',
    spareParts: {
      none: 'Kullanılan parça yok.',
      hint: 'Kullanılan parçalar iş raporlanınca gemi stoğundan düşülür.',
      part: 'Parça {{n}}',
      nothingFound: 'Eşleşen yedek parça yok; kumanya burada listelenmez.',
      onHand: 'Eldeki: {{qty}} {{unit}}',
      quantity: '{{n}}. parçanın miktarı',
      remove: '{{n}}. parçayı kaldır',
      add: 'Parça ekle',
    },
    photos: {
      upload: 'Fotoğraf ya da PDF yükle',
      hint: '25 MB’a kadar JPEG, PNG ya da PDF; fotoğraflar yüklemeden önce küçültülür.',
    },
  },
  attachments: {
    title: 'Ekler',
    none: 'Henüz ek yok.',
    kinds: { photo: 'Fotoğraf', report: 'Rapor', other: 'Diğer' },
    uploading: 'Gemiden yükleniyor',
    onVessel: 'Dosya gemide',
    voided: 'İptal edildi',
  },
  approval: {
    title: 'Başmühendis Onayı',
    pending: 'Onay bekliyor ({{step}}. adım)',
    officeStep: 'Ofisi bekliyor ({{step}}. adım)',
    approved: 'Onaylandı',
    returned: 'Düzeltmeye iade edildi',
    reportedBy: '{{at}} tarihinde {{name}} raporladı',
  },
  void: {
    void: 'İptal et',
    correct: 'Düzelt',
    voidTitle: 'İş kaydını iptal et · {{wo}}',
    correctTitle: 'İş kaydını düzelt · {{wo}}',
    voidBody: 'Kayıt gerekçenizle İPTAL işaretli olarak geçmişte kalır [NR496 4.5.3f].',
    correctBody: 'Kayıt gerekçenizle iptal edilir ve düzeltilmiş kayıt aynı adımda raporlanır.',
    reason: 'Gerekçe',
    submitCorrection: 'İptal et ve düzeltmeyi raporla',
    voidNote: 'Bu kaydı iptal ediyorsunuz. Adınız, zaman ve gerekçe kayda yazılır.',
    correctNote:
      'Bu kaydı iptal edip düzeltmeyi raporluyorsunuz. Adınız, zaman ve gerekçe kayda yazılır.',
    correcting: '{{wo}} düzeltiliyor: değerleri değiştirip yeni kaydı raporlayın.',
  },
  history: {
    title: 'İş Kayıtları',
    description: 'Geminin raporlanmış bakım kayıtları, iptal edilenler dahil.',
    tabs: { records: 'İş Geçmişi', reports: 'Raporlar', audit: 'Denetim Kaydı' },
    auditFiltered: 'Yalnız seçilen {{record}} kaydının değişiklikleri gösteriliyor.',
    auditAll: 'Bütün değişiklikleri göster',
    filters: {
      equipment: 'Ekipman',
      job: 'İş',
      from: 'Başlangıç',
      to: 'Bitiş',
      performer: 'Uygulayan',
      category: 'Kategori',
      activity: 'Etkinlik',
      all: 'Tümü',
    },
    removed: '(kaldırıldı)',
    columns: {
      doneOn: 'Yapılış',
      woNo: 'İE No',
      equipment: 'Bileşen',
      job: 'İş',
      performedBy: 'Uygulayan',
      status: 'Durum',
    },
    superseded: 'İadeden sonra yenilendi',
    voidReason: 'İptal gerekçesi: {{reason}}',
    replacedBy: '{{date}} tarihli kayıtla değişti',
    correction: 'İptal edilen kaydın düzeltmesi',
    empty: 'Henüz iş kaydı yok',
    noMatch: 'Süzgeçlere uyan kayıt yok.',
  },
  bell: {
    title: 'Bakım kararları',
    record: 'Onayınızı bekleyen iş kaydı',
    postponement: 'Kararınızı bekleyen erteleme',
    interval: 'Kararınızı bekleyen aralık değişikliği',
    defect: 'Onayınızı bekleyen arıza kapanışı',
    breakdown: 'Onayınızı bekleyen breakdown kapanışı',
  },
  library: {
    title: 'Görev Kütüphanesi',
    alarmTestBadge: 'Alarm testi',
    search: 'İş, kod, bileşen ara...',
    empty: 'Henüz bakım işi yok',
    emptyHint: 'Geminin işlerini tanımlayın: aralık, prosedür ve kontrol listesi.',
    noMatch: 'Aramaya uyan iş yok.',
    inactive: 'Etkin değil',
    columns: {
      code: 'Kod',
      title: 'İş',
      component: 'Bileşen',
      workType: 'İş Türü',
      frequency: 'Sıklık',
      lastDone: 'Son Yapılış',
      nextDue: 'Sıradaki Vade',
      status: 'Durum',
    },
  },
};
